import { render, staticRenderFns } from "./TelegramDatepicker.vue?vue&type=template&id=3784324d&"
import script from "./TelegramDatepicker.vue?vue&type=script&lang=js&"
export * from "./TelegramDatepicker.vue?vue&type=script&lang=js&"
import style0 from "./TelegramDatepicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports